import {
  getAchievements,
  getPublicAchievements,
  toggleAchievementGoal,
  getUserGoal,
} from '../api/userGoalApi';
import UserGoalCard from '../usercomponents/UserGoalCard';
import { getGoalChecks } from '../api/userGoalCheckApi';
import { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom'; // ✅ add this
import { AuthContext } from '../context/AuthContext'; // ✅ add this
import api from '../api/client'; // ✅ add this
import '../Style/achievement.css';
import '../styles.css';
import ReactionVaultBanner from '../components/ReactionVaultBanner';
import { useNavigate } from 'react-router-dom';

function UserAchievements() {
  const { userId } = useParams(); // ✅ get userId from URL if present
  const { currentUser } = useContext(AuthContext); // ✅ get logged in user
  const isOwnProfile = !userId || String(currentUser?.id) === String(userId);
  const navigate = useNavigate();
  const [achievements, setAchievements] = useState([]);
  const [openGoals, setOpenGoals] = useState({});
  const [goalDetails, setGoalDetails] = useState({});
  const [goalCheckDates, setGoalCheckDates] = useState({});
  const [viewedMonths, setViewedMonths] = useState({});

  useEffect(() => {
    const fetchAchievements = async () => {
      try {
        let res;
        if (isOwnProfile) {
          console.log('🏆 Fetching OWN achievements');
          res = await getAchievements();
        } else {
          console.log('🏆 Fetching achievements for userId:', userId);
          res = await getPublicAchievements(userId);
        }
        console.log('🏆 Achievements result:', res.data);
        setAchievements(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error('Failed to fetch achievements:', err);
        setAchievements([]);
      }
    };
    fetchAchievements();
  }, [userId, isOwnProfile]);

  console.log('isOwnProfile:', isOwnProfile);
  console.log('userId from params:', userId);
  console.log('currentUser.id:', currentUser?.id);

  const goToPreviousMonth = (goalId) => {
    const goal = achievements.find((a) => a.id === goalId);
    const current = viewedMonths[goalId] || {
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    };

    let year = current.year;
    let month = current.month - 1;
    if (month < 0) {
      month = 11;
      year -= 1;
    }

    // 🔒 LIMIT: Don't go back further than goal creation
    if (goal?.createdAt) {
      const startDate = new Date(goal.createdAt);
      const targetDate = new Date(year, month, 1);
      if (targetDate < new Date(startDate.getFullYear(), startDate.getMonth(), 1)) return;
    }

    const newState = { ...viewedMonths, [goalId]: { year, month } };
    setViewedMonths(newState);
    reloadGoalDetails(goalId, month, year);
  };

  const goToNextMonth = (goalId) => {
    const current = viewedMonths[goalId] || {
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    };

    let year = current.year;
    let month = current.month + 1;
    if (month > 11) {
      month = 0;
      year += 1;
    }

    // 🔒 LIMIT: Don't go into the future
    const today = new Date();
    if (year > today.getFullYear() || (year === today.getFullYear() && month > today.getMonth()))
      return;

    const newState = { ...viewedMonths, [goalId]: { year, month } };
    setViewedMonths(newState);
    reloadGoalDetails(goalId, month, year);
  };

  // UserAchievements.jsx

  const reloadGoalDetails = async (goalId, month, year) => {
    try {
      const currentView = viewedMonths[goalId] || {
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
      };

      const targetMonth = month !== undefined ? month : currentView.month;
      const targetYear = year !== undefined ? year : currentView.year;

      // ✅ Use public endpoint when viewing someone else's profile
      let goalRes;
      if (isOwnProfile) {
        goalRes = await getUserGoal(goalId);
      } else {
        goalRes = await api.get(`/users/${userId}/goals/${goalId}/public`);
      }
      setGoalDetails((prev) => ({ ...prev, [goalId]: goalRes.data }));

      const from = `${targetYear}-${pad2(targetMonth + 1)}-01`;
      const lastDay = new Date(targetYear, targetMonth + 1, 0).getDate();
      const to = `${targetYear}-${pad2(targetMonth + 1)}-${pad2(lastDay)}`;

      // ✅ Same for checks — use public endpoint for other users
      let checksRes;
      if (isOwnProfile) {
        checksRes = await getGoalChecks(goalId, from, to);
      } else {
        checksRes = await api.get(
          `/users/${userId}/goals/${goalId}/checks/public?from=${from}&to=${to}`,
        );
      }

      setGoalCheckDates((prev) => ({
        ...prev,
        [goalId]: checksRes.data.map((c) => c.date),
      }));
    } catch (err) {
      console.error('Error reloading goal details:', err);
    }
  };
  const pad2 = (number) => (number < 10 ? '0' + number : String(number));

  const handleViewGoal = async (goalId) => {
    const isOpen = openGoals[goalId];
    setOpenGoals((prev) => ({ ...prev, [goalId]: !isOpen }));

    if (!isOpen) {
      // 1. Fetch the data first
      await reloadGoalDetails(goalId);

      // 2. Look at the dates we just fetched
      // Note: We need to use the functional update to get the latest state
      setGoalCheckDates((prevDates) => {
        const dates = prevDates[goalId] || [];

        if (dates.length > 0) {
          // Sort dates to find the latest one (e.g., "2024-01-15")
          const latestDateStr = [...dates].sort().reverse()[0];
          const latestDate = new Date(latestDateStr);

          setViewedMonths((prevMonths) => ({
            ...prevMonths,
            [goalId]: {
              month: latestDate.getMonth(),
              year: latestDate.getFullYear(),
            },
          }));
        }
        return prevDates;
      });
    }
  };
  return (
    <div className="achievement-vault-page">
      <div className="vault-content-wrapper">
        <header className="vault-header">
          <button className="back-btn" onClick={() => navigate(-1)}>
            ← Back
          </button>

          <h1 className="vault-title">{isOwnProfile ? 'MY ACHIEVEMENTS' : 'ACHIEVEMENTS'}</h1>
        </header>
        <ReactionVaultBanner targetUserId={userId || currentUser?.id} />

        {achievements.length === 0 ? (
          <p className="vault-empty">No achievements yet.</p>
        ) : (
          <div className="vault-grid">
            {achievements.map((goal) => {
              // 1. Get the current viewed month for THIS specific goal
              // Inside achievements.map...
              const currentView =
                viewedMonths[goal.id] ||
                (goalCheckDates[goal.id]?.length > 0
                  ? {
                      // If we have dates but haven't "navigated" yet, show the month of the latest check
                      month: new Date([...goalCheckDates[goal.id]].sort().reverse()[0]).getMonth(),
                      year: new Date(
                        [...goalCheckDates[goal.id]].sort().reverse()[0],
                      ).getFullYear(),
                    }
                  : {
                      // Default to today if no checks exist
                      month: new Date().getMonth(),
                      year: new Date().getFullYear(),
                    });

              // 2. Calculate the "Start Month" (Goal Creation)
              const goalStart = goal.createdAt ? new Date(goal.createdAt) : new Date();
              const isAtFirstMonth =
                currentView.year === goalStart.getFullYear() &&
                currentView.month === goalStart.getMonth();

              // 3. Calculate the "Future" limit (Current Month)
              const today = new Date();
              const isAtCurrentMonth =
                currentView.year === today.getFullYear() && currentView.month === today.getMonth();

              return (
                <div key={goal.id} className="vault-item">
                  <UserGoalCard
                    goal={goal}
                    onView={handleViewGoal}
                    isOpen={openGoals[goal.id]}
                    selectedGoal={goalDetails[goal.id]}
                    checkDates={goalCheckDates[goal.id] || []}
                    isArchived={false}
                    isAchievementPage={true}
                    isReadOnly={!isOwnProfile}
                    viewedMonth={currentView}
                    onPrevMonth={() => goToPreviousMonth(goal.id)}
                    onNextMonth={() => goToNextMonth(goal.id)}
                    canGoBack={!isAtFirstMonth}
                    canGoForward={!isAtCurrentMonth}
                    // Achievements are read-only trophy cases
                    onMarkDoneToday={null}
                    onAddEntry={null}
                    onDeleteEntry={null}
                    onRenameEntry={null}
                    handleToggleAchievement={async (goalId) => {
                      try {
                        await toggleAchievementGoal(goalId);
                        setAchievements((prev) => prev.filter((g) => g.id !== goalId));
                      } catch (err) {
                        console.error('Failed to move achievement back:', err);
                      }
                    }}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default UserAchievements;
